module.exports = __webpack_public_path__ + "assets/0287af5f6f53086a0f7b6cb469366dd3.png";